<ion-app class="{{environment.APP_VERSION}}">
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" id="main-menu">
      <ion-content>
        <img src="/assets/icon/banner.png" class="banner" *ngIf="false">

        <ion-list>
          <ion-item lines="none" class="langSelectorFlag" *ngIf="currentLang">
            <ion-button slot="end" id="lang-selector-bt" fill="clear" color="dark">
              <span slot="start" [innerHTML]="currentLang['prefix']" style="margin-right: 1em; width: 1em;"></span>
              <ion-label>{{ currentLang['name'] }}</ion-label>
            </ion-button>
            <ion-modal trigger="lang-selector-bt" #modalLangSelector>
              <ng-template>
                <app-select-search class="ion-page" title="{{ 'Language' | translate }}" [enableFilter]="false"
                  [items]="languagesSortedbyName" [selectedItem]="currentLang['id']"
                  (selectionChange)="langSelectionChanged($event)" (selectionCancel)="modalLangSelector.dismiss()"
                  (searchChange)="langSearchChanged($event)"></app-select-search>
              </ng-template>
            </ion-modal>
          </ion-item>
        </ion-list>

        <ion-list *ngIf="isLoggedIn && userService.user">
          <ng-container *ngIf="userService.user.organization?.id">
            <ion-list-header *ngIf="userService.user.organization">{{ userService.user.organization.name
              }}</ion-list-header>
            <ion-item lines="none">
              <ion-label>
                {{ userService.user.firstName }} {{ userService.user.lastName }}<br>
                <span style="opacity: 0.4;">{{ userService.user.identifier }}</span>
              </ion-label>
            </ion-item>
          </ng-container>
          <ng-container *ngIf="!userService.user.organization?.id">
            <ion-list-header>{{ userService.user.firstName }} {{ userService.user.lastName }}</ion-list-header>
            <ion-item lines="none">
              <ion-label style="opacity: 0.6;">{{ userService.user.identifier }}</ion-label>
            </ion-item>
          </ng-container>

          <ion-menu-toggle *ngIf="platform.is('hybrid')">
            <ion-item lines="none" button (click)="shareApp()">
              <ion-icon slot="start" name="share-social-outline" size="large"></ion-icon>
              <ion-label>
                {{ 'Share the app with my friends' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle>
            <ion-item lines="none" button [routerLink]="['/organization-flowcontrol']"
              *ngIf="environment.APP_VERSION == 'SonEspaceRefuge' && (userService?.user?.organizationMember?.isRoleAdmin || userService?.user?.organizationMember?.isBenevoleWalker)">
              <ion-icon slot="start" name="journal-outline" size="large"></ion-icon>
              <ion-label>
                {{ 'Record an activity' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle>
            <ion-item lines="none" button [routerLink]="['/organization-walking']"
              *ngIf="environment.APP_VERSION == 'SonEspaceRefuge' && (userService?.user?.organizationMember?.isRoleAdmin || userService?.user?.organizationMember?.isBenevoleWalker)">
              <ion-icon slot="start" name="paw-outline" size="large"></ion-icon>
              <ion-label>
                {{ 'Walks' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          <hr>

          <ng-container
            *ngIf="['SonEspaceSante', 'SonEspaceEleveur'].includes(environment.APP_VERSION) || !userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/']">
                <ion-icon slot="start" name="home-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'Homepage' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/animal-list']">
                <ion-icon slot="start" name="paw-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'My pets' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/event-list']">
                <ion-icon slot="start" name="calendar-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'Calendar' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceRefuge'">
              <ion-item lines="none" button [routerLink]="['/plan']">
                <ion-icon slot="start" name="map-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'Plan' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceEleveur'">
              <ion-item lines="none" button [routerLink]="['/litter-list']">
                <ion-icon slot="start" name="logo-tableau" size="large"></ion-icon>
                <ion-label>
                  {{ 'My litters' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/pharmacy-product-list']">
                <ion-icon slot="start" name="medkit-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'My pharmacy' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/clinic-contact-list']">
                <ion-icon slot="start" name="storefront-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'My vets' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/compta-invoices-list']">
                <ion-icon slot="start" name="cash-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'My invoices' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/animal-share-list']">
                <ion-icon slot="start" name="share-social-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'My shares' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button (click)="discussionsCB($event)" href="#">
                <ion-icon slot="start" name="chatbox-ellipses" size="large" class="chat"></ion-icon>
                <ion-label>
                  {{ 'Discussions' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <hr>
          </ng-container>

          <ion-menu-toggle>
            <ion-item lines="none" button [routerLink]="['/user-profile-update']">
              <ion-icon slot="start" name="person-outline" size="large"></ion-icon>
              <ion-label>
                {{ 'My profile' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <hr>


          <ng-container
            *ngIf="['SonEspaceRefuge', 'SonEspaceEleveur'].includes(environment.APP_VERSION) && !userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/organization-fiche']">
                <ion-icon slot="start" name="business-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'My organization' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
              <ion-item lines="none" button [routerLink]="['/organization-member-list']">
                <ion-icon slot="start" name="people-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'The team' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceRefuge'">
              <ion-item lines="none" button [routerLink]="['/organization-fosterfamily-list']">
                <ion-icon slot="start" name="bonfire-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'Foster families' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceRefuge'">
              <ion-item lines="none" button [routerLink]="['/organization-stats']">
                <ion-icon slot="start" name="stats-chart-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'Statistics' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle
              *ngIf="false && (userService.user?.organizationMember?.isRoleAdmin || userService.user?.organizationMember?.isRoleWriteOrganization)">
              <ion-item lines="none" button [routerLink]="['/organization-subscription']">
                <ion-icon slot="start" name="cash-outline" size="large"></ion-icon>
                <ion-label>
                  {{ 'Subscription' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>
        </ion-list>

        <ion-list *ngIf="!isLoggedIn" style="margin-top: 3em;">
          <ion-menu-toggle>
            <ion-item lines="none" button [routerLink]="['/login']">
              <ion-icon slot="start" name="arrow-forward-circle-outline" color="success" size="large"></ion-icon>
              <ion-label>
                {{ 'Log in' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="environment.APP_VERSION == 'SonEspaceSante'">
            <ion-item lines="none" button [routerLink]="['/user-profile-create']">
              <ion-icon slot="start" name="add-circle-outline" size="large"></ion-icon>
              <ion-label>
                {{ 'Create an account' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <hr>

        <ion-list>
          <ion-menu-toggle>
            <ion-item lines="none" (click)="menuCtrl.close();" [routerLink]="['/contact']">
              <ion-icon slot="start" name="mail-outline" size="large"></ion-icon>
              <ion-label>
                {{ 'Contact' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle>
            <ion-item lines="none" (click)="menuCtrl.close();" [routerLink]="['/mentions-legales']">
              <ion-icon slot="start" name="information-circle-outline" size="large"></ion-icon>
              <ion-label>
                {{ 'Legal information' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <hr>

        <ion-list *ngIf="isLoggedIn && userService.user">
          <ion-menu-toggle>
            <ion-item lines="none" button (click)="logout()">
              <ion-icon slot="start" name="log-out-outline" color="danger" size="large"></ion-icon>
              <ion-label>
                {{ 'Logout' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content" [class.hideTabBar]="!showTabBar">
      <div class="sonEspaceSante-tabs" id="sonEspaceSante-tabs">
        <a tab="homepage" [routerLink]="['/']"
          *ngIf="environment.APP_VERSION != 'SonEspaceRefuge' || !userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
          <ion-icon name="home" color="dark"></ion-icon>
          <ion-label>{{ 'Homepage' | translate }}</ion-label>
        </a>
        <a tab="logbook" [routerLink]="['/logbook']" *ngIf="environment.APP_VERSION != 'SonEspaceRefuge'">
          <ion-icon name="newspaper" color="dark"></ion-icon>
          <ion-label>{{ 'Notebook' | translate }}</ion-label>
        </a>
        <a tab="animal" [routerLink]="['/animal-list']"
          *ngIf="environment.APP_VERSION != 'SonEspaceRefuge' || (environment.APP_VERSION == 'SonEspaceRefuge' && !userService?.user?.organizationMember?.isOnlyBenevoleWalker())">
          <ion-icon name="paw" color="dark"></ion-icon>
          <ion-label>{{ 'Pets' | translate }}</ion-label>
        </a>
        <a tab="event" [routerLink]="['/event-list']"
          *ngIf="environment.APP_VERSION != 'SonEspaceRefuge' || !userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
          <ion-icon name="calendar" color="dark"></ion-icon>
          <ion-label>{{ 'Agenda' | translate }}</ion-label>
        </a>
        <a tab="pharmacy" [routerLink]="['/pharmacy-product-list']" *ngIf="environment.APP_VERSION == 'SonEspaceSante'">
          <ion-icon name="medkit" color="dark"></ion-icon>
          <ion-label>{{ 'Pharmacy' | translate }}</ion-label>
        </a>
        <a tab="litter" [routerLink]="['/litter-list']" *ngIf="environment.APP_VERSION == 'SonEspaceEleveur'">
          <ion-icon name="logo-tableau"></ion-icon>
          <ion-label>{{ 'Litters' | translate }}</ion-label>
        </a>
        <a tab="plan" [routerLink]="['/plan']"
          *ngIf="environment.APP_VERSION == 'SonEspaceRefuge' && !userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
          <ion-icon name="map"></ion-icon>
          <ion-label>{{ 'Plan' | translate }}</ion-label>
        </a>
        <a tab="discussion" (click)="discussionsCB($event)" href="#"
          *ngIf="environment.APP_VERSION != 'SonEspaceRefuge' || !userService?.user?.organizationMember?.isOnlyBenevoleWalker()">
          <ion-icon name="chatbox-ellipses" class="chat"></ion-icon>
          <ion-label>{{ 'Chat' | translate }}</ion-label>
        </a>
      </div>
    </ion-router-outlet>
  </ion-split-pane>
</ion-app>